import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useInjectReducer } from 'utils/redux-injectors';
import { endpoints, baseQuery } from 'utils/api/endpoints';

export interface State {
  [key: string]: any;
}

export const initialState: State = {};

const slice = createSlice({
  name: 'orderDetailsApi',
  initialState,
  reducers: {
    someAction(state, action: PayloadAction<any>) {},
  },
});

export const api = createApi({
  reducerPath: 'orderDetailsApi',
  baseQuery,
  endpoints: builder => ({
    getOrderDetails: builder.query<any, string | number>({
      query: orderId => ({
        url: `${endpoints.ORDERS}/${orderId}`,
        method: 'GET',
      }),
    }),
    confirmOrder: builder.mutation<any, any>({
      query: body => ({
        url: `${endpoints.CONFIRM_ORDER}`,
        method: 'POST',
        body: {
          ...body,
        },
      }),
    }),
    cancelOrder: builder.mutation<any, any>({
      query: body => ({
        url: `${endpoints.CANCEL_ORDER}`,
        method: 'POST',
        body: {
          ...body,
        },
      }),
    }),
  }),
});

export const { actions: OrderDetailsActions } = slice;

export const useOrderDetailsSlice = () => {
  useInjectReducer({ key: api.reducerPath, reducer: api.reducer });
  return {
    actions: OrderDetailsActions,
    useLazyGetOrderDetailsQuery: api.useLazyGetOrderDetailsQuery,
    useConfirmOrderMutation: api.useConfirmOrderMutation,
    useCancelOrderMutation: api.useCancelOrderMutation,
  };
};
